"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterKeyIsDown = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var filterKeyIsDown = function () { return function (keyEvents$) {
    return keyEvents$.pipe((0, operators_1.filter)(function (_a) {
        var _b = tslib_1.__read(_a, 2), du = _b[0], _ev = _b[1];
        return du === 'down';
    }), (0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 2), _ = _b[0], ev = _b[1];
        return ev;
    }));
}; };
exports.filterKeyIsDown = filterKeyIsDown;
